import React from "react";
import { Controller } from "react-hook-form";

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Paper,
} from "@material-ui/core";

const membershipRows = [
  { id: "memberTextOne", placeholder: "Membership one" },
  { id: "memberTextTwo", placeholder: "Membership two" },
  { id: "memberTextThree", placeholder: "Membership three" },
];

export default function MembershipTable({ control }) {
  return (
    <TableContainer component={Paper} style={{ marginTop: 20 }}>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell width={80}>S No.</TableCell>
            <TableCell>Memberships</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {membershipRows.map((row, index) => (
            <TableRow key={row.id}>
              <TableCell>{index + 1}</TableCell>

              <TableCell>
                <Controller
                  name={row.id}
                  control={control}
                  defaultValue=""
                  render={({ value, onChange }) => (
                    <TextField
                      value={value || ""}
                      onChange={onChange}
                      placeholder={row.placeholder}
                      size="small"
                      variant="outlined"
                      fullWidth
                    />
                  )}
                />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
